// extracted by mini-css-extract-plugin
export default {"boxed":"Boxed_boxed__BoIQ-"};